import { DrillGroupBase } from './base/drill-group-base';

export class DrillGroup extends DrillGroupBase { }